import { makeAutoObservable } from 'mobx';
import { ModelValidator } from 'framework/mobx-integration';
import { AuthenticationFieldsStore } from 'areas/administration/authentication/types';
import { i18n } from 'core/localization';
import { OAuth2Authentication } from 'areas/administration/authentication/oauth2/types';

export class OAuth2FieldsStore implements AuthenticationFieldsStore {
	model = new OAuth2Authentication();
	ownerCredentials = false;
	validator: ModelValidator<OAuth2Authentication>;

	constructor(public readOnly: boolean = false) {
		makeAutoObservable(this);
		this.validator = new ModelValidator(this.model);

		this.validator
			.required('authorizationServer')
			.required('clientIdentifier')
			.required('clientSecret', () => !this.model.hasClientSecret)
			.required('username', () => this.ownerCredentials)
			.required('password', () => this.ownerCredentials && !this.model.hasPassword)
			.add('authorizationServer', {
				message: i18n('URL should start with http:// or https://'),
				callback: () => {
					const url = this.model.authorizationServer.trim();
					return !url || /^https?:\/\/\S+$/i.test(url);
				},
			});
	}

	load(record: Partial<OAuth2Authentication>) {
		Object.assign(this.model, new OAuth2Authentication(record));
		this.ownerCredentials = !!this.model.username || this.model.hasPassword;
	}

	switchOwnerCredentials(value: boolean) {
		this.ownerCredentials = value;
		this.model.clearPassword = !value && this.model.hasPassword;

		if (!value) {
			this.model.username = null;
			this.model.password = null;
		}
	}

	get payload() {
		return { ...this.model };
	}

	validate() {
		this.validator.validate();
		return this.validator.valid;
	}

	destroy() {
		this.validator.destroy();
	}
}
